export const FINAL_SCREEN_FIELDS = {
    header: 'header',
    description: 'description',
    imageSrc: 'imageSrc',
    imageDisclaimer: 'imageDisclaimer',
}
